import request from '../../../api/request';
import {
  StudyPlanOffersLoaderQuery,
  StudyPlanOffersResponseType,
  SetInterviewRequiredDto,
  AcademicOfferResponse,
} from './types';

const ENROLLMENT_AND_TUITION_CONFIG_ENDPOINT =
  'maintainers-portal/general-configuration/enrollment-and-tuition-configuration';

export function getStudyPlanOffers(query: StudyPlanOffersLoaderQuery) {
  const route = ENROLLMENT_AND_TUITION_CONFIG_ENDPOINT;
  return request<StudyPlanOffersResponseType>(route, {
    params: { academicOfferId: query.academicOfferId },
  });
}

export function getAcademicOffers() {
  return request<AcademicOfferResponse>(
    `${ENROLLMENT_AND_TUITION_CONFIG_ENDPOINT}/offers`,
  );
}

export function setInterviewRequired(data: SetInterviewRequiredDto) {
  return request<void>(
    `${ENROLLMENT_AND_TUITION_CONFIG_ENDPOINT}/set-interview-required`,
    {
      method: 'POST',
      data,
    },
  );
}
